import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import DefaultLayout from '../layouts/DefaultLayout';
import Project from '../interfaces/Project';
import { fetchWithAuth } from '../services/Fetch';
import Customer from '../interfaces/Customer';

const ProjectsList: React.FC = () => {
    const [projects, setProjects] = useState<Project[]>([]);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [customer, setCustomer] = useState<Customer | null>(null);

    const fetchCustomers = async () => {
        try {
            const response = await fetchWithAuth('/customers');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setCustomers(data.member as Customer[]);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchProjects = async () => {
        try {
            const uri = customer ? '/projects?customer=/api/customers/' + customer.id : '/projects';
            const response = await fetchWithAuth(uri);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setProjects(data.member as Project[]);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    useEffect(() => {
        fetchProjects();
        fetchCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer]);

    const copyIdentifier = (identifier: string) => {
        navigator.clipboard.writeText(identifier)
            .catch(err => alert('Erreur lors de la copie de l\'identifiant: ' + err));
    };

    const onCustomerChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setCustomer(customers.find(c => c.id.toString() === event.target.value) || null);        
    }

    return (
        <DefaultLayout>
            <h1>Projets</h1>
            <form className="row g-3 mt-3">
                <div className="col-md-3">
                    <label htmlFor="filterTool" className="form-label">Filtrer par client</label>
                    <select className="form-select" id="filterTool" value={customer?.id} onChange={onCustomerChange}>
                        <option value="">Choisir un client</option>
                        {customers.map((customer) => (
                            <option key={customer.id} value={customer.id}>
                                {customer.title}
                            </option>
                        ))}
                    </select>
                </div>
            </form>
            <table className="table table-striped mt-3">
                <thead>
                    <tr>
                        <th scope="col">Client</th>
                        <th scope="col">Nom</th>
                        <th scope="col">Url</th>
                        <th scope="col">Identifiant</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {projects.map(project => <tr key={project.id}>
                        <td>{project.customer?.title}</td>
                        <td>{project.name}</td>
                        <td><a href={project.url} target="_blank" rel="noreferrer">{project.url}</a></td>
                        <td>{project.id}</td>
                        <td>
                            <Link to={`/projects/${project.id}`} className="btn btn-primary">
                                Voir les rapports
                            </Link>
                            <Link to={`/projects/${project.id}/edit`} className="btn btn-secondary ms-2">
                                Modifier
                            </Link>
                            <button className="btn btn-secondary ms-2" onClick={() => copyIdentifier(project.id.toString())}>
                                Copier l&apos;identifiant
                            </button>
                        </td>
                    </tr>)}
                </tbody>
            </table>
            <Link to="/projects/new" className="btn btn-success">Ajouter un projet</Link>
        </DefaultLayout>
    );
}

export default ProjectsList;